'use client';

import Script from 'next/script';

const CA_PUB_ID = '3135721177140607';

const AdInArticleComponent = ({ inactive = true }: { inactive: boolean }) => {
  if (inactive) return null;
  return (
    <>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', textAlign: 'center' }}
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client={`ca-pub-${CA_PUB_ID}`}
        data-ad-slot="9988379771"
      ></ins>
      <Script id="adsbygoogle-init" strategy="afterInteractive">
        {`
          (adsbygoogle = window.adsbygoogle || []).push({});
        `}
      </Script>
    </>
  );
};

export default AdInArticleComponent;
